import { useState } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
// components
import { PATH_AFTER_LOGIN, routes } from 'src/Router/paths';
import { getRouterBasedOnUserStats } from 'src/utils/user-utils';
import { LoadingScreen } from '../components/loading-screen';
//
import { useAuthContext } from './useAuthContext';

type AuthGuardProps = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();

  const [searchParams] = useSearchParams();

  const workspaceInvite = searchParams.get('workspaceInvite');

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null,
  );

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to="/login" replace />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  const isInWizard = pathname.startsWith(routes.wizard.root);

  if (user && !isInWizard && !workspaceInvite) {
    const forceRedirect = getRouterBasedOnUserStats({
      workspaceInvite: workspaceInvite as string,
    });
    if (forceRedirect !== PATH_AFTER_LOGIN && pathname !== forceRedirect) {
      return <Navigate to={forceRedirect} />;
    }
  }

  return <> {children} </>;
}
